import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import validate from './OrgUnitAdminContactsDetailValidation'

import NavLinks from '../../../../meet/NavLinks';
import EntryNavLinks from '../../../EntryNavLinks';

import useOrgUnitAdminMeetInfo from '../UseOrgUnitAdminMeetInfo';

import useOmeMeetData from '../../../../../state/omeMeet/UseOmeMeetData';
import useOmeMeetOrgUnitEntryData from '../../../../../state/omeMeetOrgUnitEntry/UseOmeMeetOrgUnitEntryData';
import useOmeMeetOrgUnitEntryInfoData from '../../../../../state/omeMeetOrgUnitEntryInfo/UseOmeMeetOrgUnitEntryInfoData';
import useOmeMeetOrgUnitContactData from '../../../../../state/omeMeetOrgUnitContact/UseOmeMeetOrgUnitContactData';
import useOmeMeetOrgUnitEntryRosterPermissionsData from '../../../../../state/omeMeetOrgUnitEntryRosterPermissions/UseOmeMeetOrgUnitEntryRosterPermissionsData';

import useLeftNavModalData from '@usas/ui-web/state/leftNavModal/UseLeftNavModalData';

import UseForm from "@usas/ui-web/utils/UseForm";

const useOrgUnitAdminContactsDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { omeMeetState } = useOmeMeetData();
  const { omeMeetOrgUnitEntryState, getOmeMeetOrgUnitEntryById } = useOmeMeetOrgUnitEntryData();
  const { omeMeetOrgUnitEntryInfoState } = useOmeMeetOrgUnitEntryInfoData();
  const { omeMeetOrgUnitContactState, postOmeMeetOrgUnitContact, putOmeMeetOrgUnitContact, confirmSaveOmeMeetOrgUnitContact } = useOmeMeetOrgUnitContactData();
  const { omeMeetOrgUnitEntryRosterPermissionsState, putOmeMeetOrgUnitEntryRosterPermissions } = useOmeMeetOrgUnitEntryRosterPermissionsData();
  const { leftNavModalState, setLeftNavModalState } = useLeftNavModalData();
  const { formStateHasBeenSaved, updateOmeMeetOrgUnitEntryRosterPermissionsObject } = useOrgUnitAdminMeetInfo();
  const { formState, errorState, setFormData, setErrors, onFormValueChanged, handleSubmit, isDirty, setIsDirty
  } = UseForm(getInitialFormState(), submitFormCallback, validate);
  const [state, setState] = useState({ tryGetOmeMeet: false, tryRedirect: false });

  const tryValidateBeforeRedirect = async () => {
    const errors = await validate(formState) || {};
    setErrors(errors);
    if (Object.keys(errors).length === 0) {
      setState({ ...state, tryRedirect: true });
    }
  };

  const onNextButtonClicked = (e) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }

    if (isDirty === false) {
      tryValidateBeforeRedirect();
    }
    else {
      handleSubmit();
    }
  };

  const onBackButtonClicked = (e) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }

    if (omeMeetState.route !== '') {
      navigate(NavLinks.OU_ADMIN_MEET_INFO, { state: { meetInfoFormState: formState.meetInfoFormState } });
    }
    else {
      navigate(EntryNavLinks.OU_ADMIN_MEET_INFO, { state: { meetInfoFormState: formState.meetInfoFormState } });
    }
  };

  useEffect(() => {
    if (location.state) {
      setFormData({
        ...formState,
        meetInfoFormState: location.state?.meetInfoFormState || {},
        omeMeetOrgUnitContactId: location.state?.omeMeetOrgUnitContactId || '',
        personId: location.state?.personId || '',
        memberId: location.state?.memberId || '',
        emailAddress: location.state?.emailAddress || ''
      });
      //Edit
      if (location.state?.omeMeetOrgUnitContactId > 0) {
        if (formStateHasBeenSaved(location.state?.meetInfoFormState) === false) {
          setIsDirty(true);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const isSaved = formStateHasBeenSaved(location.state?.meetInfoFormState);
    const isContactDetailSaved = contactsDetailFormStateHasBeenSaved(formState);
    const isOverallSaved = isSaved === true && isContactDetailSaved === true ? true : false;
    setLeftNavModalState({ ...leftNavModalState, formStateSaved: isOverallSaved });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state?.meetInfoFormState, formState, omeMeetOrgUnitContactState, omeMeetOrgUnitEntryRosterPermissionsState]);

  useEffect(() => {
    if (state.tryGetOmeMeet === true && omeMeetOrgUnitContactState.isSaving === false &&
      omeMeetOrgUnitContactState.isSaved === true && omeMeetOrgUnitEntryRosterPermissionsState.isSaving === false) {
      confirmSaveOmeMeetOrgUnitContact();
      getOmeMeetOrgUnitEntryById(omeMeetState.objData?.omeMeetId, omeMeetOrgUnitEntryState.objData?.omeMeetEntryId, omeMeetOrgUnitEntryState.objData?.omeMeetOrgUnitEntryId);
      setState({ ...state, tryGetOmeMeet: false, tryRedirect: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.tryGetOmeMeet, omeMeetOrgUnitContactState, omeMeetOrgUnitEntryRosterPermissionsState])

  useEffect(() => {
    if (state.tryRedirect === true && omeMeetOrgUnitEntryState.isObjLoading === false &&
      omeMeetOrgUnitEntryState.isObjLoaded === true) {
      if (omeMeetState.route === '') {
        //OME Route
        navigate(EntryNavLinks.OU_ADMIN_MEET_INFO, { state: { tryGetContacts: true } });
      }
      else {
        //Meet Route
        navigate(NavLinks.OU_ADMIN_MEET_INFO, { state: { tryGetContacts: true } });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.tryRedirect, omeMeetOrgUnitEntryState])

  function contactsDetailFormStateHasBeenSaved(formState) {
    //compare contacts detail formState to omeMeetOrgUnitContactState to see if formState has been saved
    //Edit contact
    if (formState?.omeMeetOrgUnitContactId !== '') {
      const selectedOmeMeetOrgUnitContact = omeMeetOrgUnitContactState.arrayData?.find(x =>
        x.omeMeetOrgUnitContactId === formState?.omeMeetOrgUnitContactId);
      if (formState?.memberId !== selectedOmeMeetOrgUnitContact?.memberId
        && (formState?.memberId !== '' || selectedOmeMeetOrgUnitContact?.memberId !== null)) {
        return false;
      }
      if (formState?.emailAddress !== selectedOmeMeetOrgUnitContact?.emailAddress
        && (formState?.emailAddress !== '' || selectedOmeMeetOrgUnitContact?.emailAddress !== null)) {
        return false;
      }
    }
    //Add contact
    else {
      if (isDirty === true) {
        return false;
      }
      return true;
    }

    return true;
  }

  function submitFormCallback(formState) {
    //Save Meet Info, if needed
    if (formStateHasBeenSaved(location.state?.meetInfoFormState) === false) {
      putOmeMeetOrgUnitEntryRosterPermissions(omeMeetOrgUnitEntryState?.objData?.omeMeetOrgUnitEntryId, updateOmeMeetOrgUnitEntryRosterPermissionsObject(location.state?.meetInfoFormState));
    }

    //Save Contact
    if (formState.omeMeetOrgUnitContactId) {
      const omeMeetOrgUnitContactObj = {
        omeMeetOrgUnitContactId: formState.omeMeetOrgUnitContactId,
        orgUnitId: omeMeetOrgUnitEntryState.objData.orgUnitId,
        omeMeetId: omeMeetOrgUnitEntryInfoState.objData.omeMeetId,
        personId: formState.personId,
        emailAddress: formState.emailAddress.trim(),
      };
      putOmeMeetOrgUnitContact(formState.omeMeetOrgUnitContactId, omeMeetOrgUnitContactObj);
    }
    else {
      const omeMeetOrgUnitContactObj = {
        orgUnitId: omeMeetOrgUnitEntryState.objData.orgUnitId,
        omeMeetId: omeMeetOrgUnitEntryInfoState.objData.omeMeetId,
        personId: formState.personId,
        emailAddress: formState.emailAddress.trim(),
      };

      postOmeMeetOrgUnitContact(omeMeetOrgUnitContactObj);
    }
    setState({ ...state, tryGetOmeMeet: true });
  }

  function getInitialFormState() {
    return ({
      omeMeetOrgUnitContactId: '',
      personId: '',
      memberId: '',
      emailAddress: ''
    })
  }

  return {
    omeMeetOrgUnitEntryState,
    omeMeetOrgUnitContactState,
    omeMeetOrgUnitEntryRosterPermissionsState,
    formState,
    errorState,
    handleSubmit,
    setFormData,
    onFormValueChanged,
    onNextButtonClicked,
    onBackButtonClicked
  };
};

export default useOrgUnitAdminContactsDetail;